'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Consumer = exports.Provider = undefined;

var _consumer = require('./consumer');

var _consumer2 = _interopRequireDefault(_consumer);

var _provider = require('./provider');

var _provider2 = _interopRequireDefault(_provider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Provider = _provider2.default;
exports.Consumer = _consumer2.default;


// WEBPACK FOOTER //
// ./node_modules/xfc/lib/index.js